import { Grid } from '@mui/material'
import { CameraIconBlueBackground, UploadBlueBackground } from 'icons'
import { LargeIconButton } from 'components/core-ui/LargeIconButton'
import { WebcamCapture } from 'components/core-ui/WebcamCapture'
import { FormFileUpload } from 'components/core-ui/FormFileUpload'
import s from './ImageCapture.modules.scss'
import { ChangeEvent } from 'react'

export interface ImageCaptureProps {
  images: File[]
  setImages: (images: File[]) => void
  showPhotoCapture: boolean
  setShowPhotoCapture: (showPhotoCapture: boolean) => void
  accept?: string
}

const ImageCapture = (props: ImageCaptureProps) => {
  const { images, setImages, showPhotoCapture, setShowPhotoCapture, accept } = props

  const onFileUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files[0]
    setImages([...images, file])
  }

  const onImageCapture = (imageSrc: string) => {
    fetch(imageSrc)
      .then(res => res.blob())
      .then(blob => {
        const file = new File([blob], `image_${Date.now()}.png`, { type: 'image/png' })
        setImages([...images, file])
        setShowPhotoCapture(false)
      })
  }

  return (
    <Grid container spacing={4}>
      {showPhotoCapture ? (
        <Grid xs={12} item style={{ textAlign: 'center' }}>
          <WebcamCapture
            onImageCapture={onImageCapture}
            videoConstraints={{ width: 1920, height: 1080, facingMode: 'environment' }}
            buttonStyle={{ width: '100%', margin: '24px 0' }}
          />
        </Grid>
      ) : (
        <>
          <Grid xs={12} md={6} item>
            <LargeIconButton
              label="Camera"
              startIcon={<CameraIconBlueBackground />}
              onClick={() => setShowPhotoCapture(true)}
            />
          </Grid>
          <Grid xs={12} md={6} item className={s.btnContainer}>
            <FormFileUpload
              onChange={onFileUpload}
              icon={<UploadBlueBackground />}
              text="Upload documente"
              buttonContainerClassName={s.fileUploadBtn}
              fileContainerClassName={s.uploadedFileContainer}
              accept={accept}
            />
          </Grid>
        </>
      )}
    </Grid>
  )
}

export default ImageCapture
